import { jsx as _jsx, jsxs as _jsxs } from "tsx-dom/jsx-runtime";
import { text } from "../i18n";
const shortcutModifier = navigator.userAgent.includes("Mac OS X")
    ? "Command"
    : "Ctrl";
/**
 * @returns The HTMLElement representing the clipboard permission modal
 */
export function ClipboardPermission() {
    return (_jsx("div", { id: "clipboard-modal", class: "modal hidden", children: _jsxs("div", { class: "modal-area", children: [_jsx("span", { class: "close-modal" }), _jsx("h2", { children: text("clipboard-message-title") }), _jsx("p", { id: "clipboard-modal-description" }), _jsxs("p", { children: [_jsxs("b", { children: [shortcutModifier, "+C"] }), _jsx("span", { children: text("clipboard-message-copy") })] }), _jsxs("p", { children: [_jsxs("b", { children: [shortcutModifier, "+X"] }), _jsx("span", { children: text("clipboard-message-cut") })] }), _jsxs("p", { children: [_jsxs("b", { children: [shortcutModifier, "+V"] }), _jsx("span", { children: text("clipboard-message-paste") })] })] }) }));
}
